// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"letters-k"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 19V5M16 19V17.2573C16 17.0958 15.922 16.9443 15.7906 16.8504L9.5 12.3571M16 5V6.74269C16 6.90417 15.922 7.0557 15.7906 7.14956L9.5 11.6429","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-letters-k')
export default class LettersKIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'letters-k',
    }
  }
}
